module.exports = __webpack_public_path__ + "img/i_empty_n.68240392.svg";